// Addresses
export const tokenContractAddress = '0x9E44873649A8A45589932A220f8e7861F45f78C7'; // Token Contract Address
export const consensusContractAddress = '0x110E819B35C2dBb77D12f9EeaE3e7a794e839737'; // Consensus Contract Address
export const governanceContractAddress = '0x6D41E39b9eB4153a444DF0bc9C1566961Ba913f5'; // Governance Contract Address
export const rewardContractAddress = '0x69F00311105F0B8f71A438c737b51DDf382052Fb'; // Reward Contract Address
export const liquidityContractAddress = '0xD80614C4ECCe953B8F86352E47d31ca11B4cd223'; // Liquidity Contract Address
